import rooms from '../content/rooms/room.json';
import roomStyles from '../content/rooms/roomstyles.json';
import roomGallery from '../content/rooms/roomgallery.json';
import roomRatings from '../content/rooms/roomrating.json';
import roomLikes from '../content/rooms/roomlike.json';
import reservations from '../content/rooms/roomreservation.json';
import foodTypes from '../content/foods/foodtype.json';
import foods from '../content/foods/food.json';
import foodContents from '../content/foods/foodcontent.json';
import foodContentsLinks from '../content/foods/food_food_content.json';
import foodOrders from '../content/foods/foodorder.json';
import foodLikes from '../content/foods/foodlike.json';
import articles from '../content/blog/article.json';
import articleGroups from '../content/blog/articlegroup.json';
import ads from '../content/blog/advertising.json';
import gallery from '../content/hotel/gallery.json';

export const getRoomsResponse = () => ({
  ser_data: rooms.map(room => ({
    ...room,
    room_styles: roomStyles.find(s => s.id === room.room_styles_id) || null,
    room_gallery: roomGallery.filter(g => g.room_id === room.id),
  })),
  ser_room_likes: roomLikes.map(like => ({
    ...like,
    room: like.room_id,
    user_liked: like.user_liked_id,
  })),
  ser_room_rating: roomRatings.map(rate => ({
    ...rate,
    room: rate.room_id,
    user_liked: rate.user_liked_id,
  })),
});

export const getGallery = () => gallery;

export const getFoodsResponse = () => foods.map(food => ({
  ...food,
  food_type: foodTypes.find(t => t.id === food.type_id) || null,
  food_content: foodContents.filter(c =>
    foodContentsLinks.some(l => l.food_id === food.id && l.foodcontent_id === c.id)
  ),
}));

export const getFoodTypesResponse = () => foodTypes.map(type => ({
  ...type,
  name: type.type_name,
  foods_type: foods.filter(f => f.type_id === type.id),
}));

export const getArticlesResponse = () => articles.map(article => ({
  ...article,
  description: article.text,
  group_title: articleGroups.find(g => g.id === article.group_title_id) || null,
}));

export const getAdvertising = () => ads;

export const getFoodLikes = () => foodLikes.map(like => ({
  ...like,
  food: like.food_id,
  user_liked: like.user_liked_id,
}));

export const getReservations = () => reservations.map(res => ({
  ...res,
  room: res.room_id,
  reservatore: res.reservatore_id,
}));

export const getCart = () => ({
  reservations: reservations.map(res => ({
    ...res,
    room: rooms.find(r => r.id === res.room_id) || null,
    reservatore: res.reservatore_id,
  })),
  orders: foodOrders.map(order => ({
    ...order,
    food: foods.find(f => f.id === order.food_id) || null,
    Client: order.Client_id,
  })),
});

export const getFoodOrders = () => foodOrders.map(order => ({
  ...order,
  food: foods.find(f => f.id === order.food_id) || null,
  Client: order.Client_id,
}));

export const findRoomById = (id) => rooms.find(r => r.id === Number(id)) || null;
export const findFoodById = (id) => foods.find(f => f.id === Number(id)) || null;
